export default __webpack_public_path__ + "static/media/pxec02-ads.27fbf41c.png";